<template>
  <div class="text-center">
    <li class="row">
      <div id="start" class="map-legend column">SP</div>
      <div class="column ml-3">Starting Point</div>
    </li>
    <li class="row">
      <div id="end" class="map-legend column">EP</div>
      <div class="column ml-3">End Point</div>
    </li>
    <li class="row">
      <div id="primary-route" class="map-legend"></div>
      <div class="column ml-3">Primary Route</div>
    </li>
    <li class="row pt-2">
      <div id="alternate-route" class="map-legend"></div>
      <div class="column ml-3">Alternate Route</div>
    </li>
    <li class="row">
      <div class="map-legend column align-center">
        <div id="mile-marker">1</div>
      </div>
      <div class="column ml-3">Mile Marker</div>
    </li>
    <li class="row">
      <div class="map-legend">
        <div id="ambulance"></div>
      </div>
      <div class="column ml-3">WTA Ambulance Pick Up Point</div>
    </li>
  </div>
</template>

<script>
export default {
  name: "MapLegendLi",
  props: {}
};
</script>

<style scoped>
li {
  align-items: center;
  margin-bottom: 1rem;
  list-style-type: none;
}
.map-legend {
  width: 40px;
  font-weight: bold;
}
#start {
  background-color: #43b649;
  padding: 0.5rem;
  border-radius: 60%;
}
#end {
  background-color: #f1ae22;
  padding: 0.5rem;
  border-radius: 60%;
}
#primary-route {
  border: 3px solid #82b0de;
}
#alternate-route {
  border-bottom: 3px dashed #16bfe8;
}
#mile-marker {
  background-color: #f26a2d !important;
  padding: 0.5rem;
  border-radius: 60%;
}
#ambulance {
  background: #de1d24;
  height: 25px;
  left: 15px;
  position: relative;
  width: 10px;
}
#ambulance:after {
  background: #de1d24;
  content: "";
  height: 10px;
  left: -7.5px;
  position: absolute;
  top: 7px;
  width: 25px;
}
</style>